export default __webpack_public_path__ + "static/media/phone-1-black@2x.ef8ad366.png";